import parse from "html-react-parser";
import moment from "moment";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import "./BlogsSection.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination } from "swiper/modules";
import { Skeleton } from "antd";
export default function BlogsSection({ blogData }) {
  return (
    <div className="section-spacing-x section-spacing-x-mobile">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 mx-auto text-center main-heading-box">
            <h2 className="main-heading">
              Blooming Ideas for Floral Inspiration
            </h2>
            <p>
              Check our blog for tips and ideas on flowers and gifts for your
              celebrations
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <Swiper
              pagination={{
                dynamicBullets: true,
                clickable: true,
              }}
              slidesPerView={1}
              spaceBetween={20}
              // autoplay="flase"
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              breakpoints={{
                640: {
                  slidesPerView: 1,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 10,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
              }}
              modules={[Autoplay, Pagination]}
              className="mySwiper blog-section-swiper pb-4">
              {blogData.length > 0 ? (
                blogData?.map((data, index) => {
                  return (
                    <SwiperSlide
                      // className="col-md-6 col-lg-4 mb-4 mb-lg-0"
                      key={`blog-${index}`}>
                      <div className="blog-card border">
                        <Link
                          to={{
                            pathname: `/blog-detail/${data.fld_title}`,
                            state: { data },
                          }}>
                          <img
                            alt={data.fld_title}

                            src={data.fld_blogimage}
                            className="img-fluid w-100"
                          />
                        </Link>
                        <span className="date-box">
                          <p>
                            {moment(data.fld_createdon, "DD/MM/YYYY").format(
                              "DD"
                            )}
                          </p>
                          <b>
                            {moment(data.fld_createdon, "DD/MM/YYYY").format(
                              "MMM"
                            )}
                          </b>
                          <b>
                            {moment(data.fld_createdon, "DD/MM/YYYY").format(
                              "YYYY"
                            )}
                          </b>
                        </span>
                        <div className="content">
                          <p className="title">
                            <Link
                              to={{
                                pathname: `/blog-detail/${data.fld_title}`,
                                state: { data },
                              }}>
                              {data.fld_title}
                            </Link>
                          </p>
                          <p className="blog-des">
                            {parse(data.fld_short_description)}
                          </p>
                          <Link
                            to={{
                              pathname: `/blog-detail/${data.fld_title
                                .toLowerCase()
                                .replace(/ /g, "-")}`,
                              state: { data },
                            }}
                            className="theme-btn">
                            Read More
                          </Link>
                        </div>
                      </div>
                    </SwiperSlide>
                  );
                })
              ) : (
                <>
                  <SwiperSlide>
                    {" "}
                    <div className="blog-card border blog-section-skeleton">
                      <Skeleton.Image alt="" className="img-fluid w-100" />

                      <div className="content">
                        <Skeleton.Input className="w-100 mb-1" />

                        <Skeleton.Input className="w-75" />
                        <Skeleton.Input className="mt-3" />
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="blog-card border blog-section-skeleton">
                      <Skeleton.Image alt="" className="img-fluid w-100" />

                      <div className="content">
                        <Skeleton.Input className="w-100 mb-1" />

                        <Skeleton.Input className="w-75" />
                        <Skeleton.Input className="mt-3" />
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="blog-card border blog-section-skeleton">
                      <Skeleton.Image alt="" className="img-fluid w-100" />

                      <div className="content">
                        <Skeleton.Input className="w-100 mb-1" />

                        <Skeleton.Input className="w-75" />
                        <Skeleton.Input className="mt-3" />
                      </div>
                    </div>
                  </SwiperSlide>
                  <SwiperSlide>
                    <div className="blog-card border blog-section-skeleton">
                      <Skeleton.Image alt="" className="img-fluid w-100" />

                      <div className="content">
                        <Skeleton.Input className="w-100 mb-1" />

                        <Skeleton.Input className="w-75" />
                        <Skeleton.Input className="mt-3" />
                      </div>
                    </div>
                  </SwiperSlide>
                </>
              )}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
}
